// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimelineTab-module__font-s-10___zP9OO {
  font-size: 10px !important;
}

.TimelineTab-module__font-s-12___aBgVC {
  font-size: 12px !important;
}

.TimelineTab-module__font-s-13___orH8c {
  font-size: 13px !important;
}

.TimelineTab-module__font-s-14___f4BL3 {
  font-size: 14px !important;
}

.TimelineTab-module__font-s-15___CBcI1 {
  font-size: 15px !important;
}

.TimelineTab-module__font-s-16___yaoBP {
  font-size: 16px !important;
}

.TimelineTab-module__font-s-18___nllZj {
  font-size: 18px !important;
}

.TimelineTab-module__font-s-20___3t6w3 {
  font-size: 20px !important;
}

.TimelineTab-module__font-s-22___GE1_m {
  font-size: 22px !important;
}

.TimelineTab-module__font-s-28___wlAz8 {
  font-size: 28px !important;
}

.TimelineTab-module__font-w-400___DdWGl {
  font-weight: 400 !important;
}

.TimelineTab-module__font-w-500___RAMgV {
  font-weight: 500 !important;
}

.TimelineTab-module__font-w-600___IOhVh {
  font-weight: 600 !important;
}

.TimelineTab-module__font-w-700___RROa2 {
  font-weight: 700 !important;
}

.TimelineTab-module__p-5___tv4ol {
  padding: 5px !important;
}

.TimelineTab-module__p-12___lEGSm {
  padding: 12px !important;
}

.TimelineTab-module__p-16___nGOxC {
  padding: 16px !important;
}

.TimelineTab-module__p-30___figqS {
  padding: 30px !important;
}

.TimelineTab-module__p-b-0___vBK1c {
  padding-bottom: 0 !important;
}

.TimelineTab-module__p-b-5___eLYke {
  padding-bottom: 5px !important;
}

.TimelineTab-module__p-b-10___s9tWp {
  padding-bottom: 10px !important;
}

.TimelineTab-module__p-b-12___H3D5n {
  padding-bottom: 12px !important;
}

.TimelineTab-module__p-b-16___zkAUF {
  padding-bottom: 16px !important;
}

.TimelineTab-module__p-b-18___frSoz {
  padding-bottom: 18px !important;
}

.TimelineTab-module__p-b-20___FM7t4 {
  padding-bottom: 20px !important;
}

.TimelineTab-module__p-b-25___vNT3e {
  padding-bottom: 25px !important;
}

.TimelineTab-module__p-b-30___Un5_p {
  padding-bottom: 30px !important;
}

.TimelineTab-module__p-b-50___xpJ8S {
  padding-bottom: 50px !important;
}

.TimelineTab-module__p-t-0___drkxQ {
  padding-top: 0 !important;
}

.TimelineTab-module__p-t-12___vKzaU {
  padding-top: 12px !important;
}

.TimelineTab-module__p-t-16___pjjch {
  padding-top: 16px !important;
}

.TimelineTab-module__p-t-18___HOtrG {
  padding-top: 18px !important;
}

.TimelineTab-module__p-t-20___DcFlE {
  padding-top: 20px !important;
}

.TimelineTab-module__p-t-30___mWNMO {
  padding-top: 30px !important;
}

.TimelineTab-module__p-t-40___cUuTa {
  padding-top: 40px !important;
}

.TimelineTab-module__p-t-50___wYKuk {
  padding-top: 50px !important;
}

.TimelineTab-module__p-l-20___egobj {
  padding-left: 20px !important;
}

.TimelineTab-module__p-l-30___M_ud4 {
  padding-left: 30px !important;
}

.TimelineTab-module__p-l-40___Esh1f {
  padding-left: 40px !important;
}

.TimelineTab-module__p-r-16___D7UZk {
  padding-right: 16px !important;
}

.TimelineTab-module__p-r-20___CtTAI {
  padding-right: 20px !important;
}

.TimelineTab-module__p-r-30___zaj31 {
  padding-right: 30px !important;
}

.TimelineTab-module__p-r-50___OmxiI {
  padding-right: 50px !important;
}

.TimelineTab-module__p-r-60___kSL5J {
  padding-right: 60px !important;
}

.TimelineTab-module__m-b-1___AbmEC {
  margin-bottom: 1px !important;
}

.TimelineTab-module__m-b-2___laGij {
  margin-bottom: 2px !important;
}

.TimelineTab-module__m-b-6___c53tt {
  margin-bottom: 6px !important;
}

.TimelineTab-module__m-b-8___nrZfY {
  margin-bottom: 8px !important;
}

.TimelineTab-module__m-b-10___NApLA {
  margin-bottom: 10px !important;
}

.TimelineTab-module__m-b-14___i2lBq {
  margin-bottom: 14px !important;
}

.TimelineTab-module__m-b-16___NNs5G {
  margin-bottom: 16px !important;
}

.TimelineTab-module__m-b-20____vbQi {
  margin-bottom: 20px !important;
}

.TimelineTab-module__m-b-22___M1ai3 {
  margin-bottom: 22px !important;
}

.TimelineTab-module__m-b-24___yf4yG {
  margin-bottom: 24px !important;
}

.TimelineTab-module__m-b-30___fRbMn {
  margin-bottom: 30px !important;
}

.TimelineTab-module__m-b-32___gul3L {
  margin-bottom: 32px !important;
}

.TimelineTab-module__m-b-40___cAncs {
  margin-bottom: 40px !important;
}

.TimelineTab-module__m-t-2___LJFzu {
  margin-top: 2px !important;
}

.TimelineTab-module__m-t-3___SuVs0 {
  margin-top: 3px !important;
}

.TimelineTab-module__m-t-4___zVf4W {
  margin-top: 4px !important;
}

.TimelineTab-module__m-t-5___co0RO {
  margin-top: 5px !important;
}

.TimelineTab-module__m-t-8___JAblo {
  margin-top: 8px !important;
}

.TimelineTab-module__m-t-10___kPrcf {
  margin-top: 10px !important;
}

.TimelineTab-module__m-t-15___kKwxi {
  margin-top: 15px !important;
}

.TimelineTab-module__m-t-16___JSQP2 {
  margin-top: 16px !important;
}

.TimelineTab-module__m-t-20___ipR27 {
  margin-top: 20px !important;
}

.TimelineTab-module__m-t-22___BPQSE {
  margin-top: 22px !important;
}

.TimelineTab-module__m-t-30___CvzdJ {
  margin-top: 30px !important;
}

.TimelineTab-module__m-t-32___bOCTZ {
  margin-top: 32px !important;
}

.TimelineTab-module__m-l-auto___i38ji {
  margin-left: auto !important;
}

.TimelineTab-module__m-l-4___tMSVo {
  margin-left: 4px !important;
}

.TimelineTab-module__m-l-5___mAjNU {
  margin-left: 5px !important;
}

.TimelineTab-module__m-l-6___UtQLs {
  margin-left: 6px !important;
}

.TimelineTab-module__m-l-8___sKmot {
  margin-left: 8px !important;
}

.TimelineTab-module__m-l-10___FWFC1 {
  margin-left: 10px !important;
}

.TimelineTab-module__m-l-16___dU1Gz {
  margin-left: 16px !important;
}

.TimelineTab-module__m-l-20___akMXq {
  margin-left: 20px !important;
}

.TimelineTab-module__m-l-24___yyRFN {
  margin-left: 24px !important;
}

.TimelineTab-module__m-l-30___M2R8s {
  margin-left: 30px !important;
}

.TimelineTab-module__m-l-35___OGxSu {
  margin-left: 35px !important;
}

.TimelineTab-module__m-l-40___ufumg {
  margin-left: 40px !important;
}

.TimelineTab-module__m-r-8___yPf0K {
  margin-right: 8px !important;
}

.TimelineTab-module__m-r-10___NDhcq {
  margin-right: 10px !important;
}

.TimelineTab-module__m-r-16___NiGsy {
  margin-right: 16px !important;
}

.TimelineTab-module__m-r-20___GdHbE {
  margin-right: 20px !important;
}

.TimelineTab-module__m-r-24___WgCsf {
  margin-right: 24px !important;
}

.TimelineTab-module__m-r-30___DIJM_ {
  margin-right: 30px !important;
}

.TimelineTab-module__m-r-40___eocs_ {
  margin-right: 40px !important;
}

.TimelineTab-module__border-r-3___YcsSZ {
  border-radius: 3px !important;
}

.TimelineTab-module__border-r-4___hqjmk {
  border-radius: 4px !important;
}

.TimelineTab-module__border-r-6___BslTj {
  border-radius: 6px !important;
}

.TimelineTab-module__border-r-10___sA5Ak {
  border-radius: 10px !important;
}

.TimelineTab-module__border-r-12___OwOo1 {
  border-radius: 12px !important;
}

.TimelineTab-module__border-r-16___S4JWw {
  border-radius: 16px !important;
}

.TimelineTab-module__border-r-50___SE3Y_ {
  border-radius: 50% !important;
}

.TimelineTab-module__primary-border___juEzT {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineTab-module__primary-border-b___L5zkv {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineTab-module__primary-border-t___BLnQg {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineTab-module__primary-border-l___hYm1t {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineTab-module__primary-border-r____Xhzc {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineTab-module__secondary-border___MwZIP {
  border: 1px solid #637768;
}

.TimelineTab-module__secondary-border-b___I2VqW {
  border-bottom: 1px solid #637768;
}

.TimelineTab-module__secondary-border-t___CBjIM {
  border-top: 1px solid #637768;
}

.TimelineTab-module__secondary-border-l___ox0OL {
  border-left: 1px solid #637768;
}

.TimelineTab-module__secondary-border-r___W5JoP {
  border-right: 1px solid #637768;
}

.TimelineTab-module__gap-0___pa6c0 {
  gap: 0 !important;
}

.TimelineTab-module__gap-2___QCozg {
  gap: 2px !important;
}

.TimelineTab-module__gap-4___DiBjj {
  gap: 4px !important;
}

.TimelineTab-module__gap-5___W_AKF {
  gap: 5px !important;
}

.TimelineTab-module__gap-6___bvOEP {
  gap: 6px !important;
}

.TimelineTab-module__gap-8___zoEyg {
  gap: 8px !important;
}

.TimelineTab-module__gap-10___JdhNH {
  gap: 10px !important;
}

.TimelineTab-module__gap-12___uHriY {
  gap: 12px !important;
}

.TimelineTab-module__gap-14___ZN0Ha {
  gap: 14px !important;
}

.TimelineTab-module__gap-16___CfauV {
  gap: 16px !important;
}

.TimelineTab-module__gap-18___dx8Qm {
  gap: 18px !important;
}

.TimelineTab-module__gap-20___ZX9Ql {
  gap: 20px !important;
}

.TimelineTab-module__gap-24___jgVbt {
  gap: 24px !important;
}

.TimelineTab-module__gap-26___G3Wg1 {
  gap: 26px !important;
}

.TimelineTab-module__gap-30___qhSeo {
  gap: 30px !important;
}

.TimelineTab-module__gap-32___vWLVP {
  gap: 32px !important;
}

.TimelineTab-module__gap-40___leUwX {
  gap: 40px !important;
}

.TimelineTab-module__gap-50___zZB7H {
  gap: 50px !important;
}

.TimelineTab-module__flex-1___e7TkB {
  flex: 1;
}

.TimelineTab-module__flex-none___d0BnB {
  flex: none !important;
}

.TimelineTab-module__flex-column___oezP_ {
  display: flex;
  flex-direction: column !important;
}

.TimelineTab-module__flex-row___wus0j {
  display: flex;
  flex-direction: row !important;
}

.TimelineTab-module__vertically-centered___tkotu {
  display: flex;
  align-items: center !important;
}

.TimelineTab-module__horizontally-centered___sRcha {
  display: flex;
  justify-content: center !important;
}

.TimelineTab-module__horizontally-end___LY7lN {
  display: flex;
  justify-content: end !important;
}

.TimelineTab-module__vertically-start___Htznd {
  display: flex;
  align-items: start !important;
}

.TimelineTab-module__space-between___P5kUT {
  display: flex;
  justify-content: space-between !important;
}

.TimelineTab-module__flex-wrap___ObNba {
  flex-wrap: wrap !important;
}

.TimelineTab-module__height-100___NUg7e {
  height: 100%;
}

.TimelineTab-module__width-50___GQyRE {
  width: 50% !important;
}

.TimelineTab-module__width-100___VVwOg {
  width: 100%;
}

.TimelineTab-module__cursor-pointer___lLhjF {
  cursor: pointer;
}

.TimelineTab-module__cursor-not-allowed___GVVQC {
  cursor: not-allowed !important;
}

.TimelineTab-module__absolute-centered___HwHmA {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TimelineTab-module__absolute___DVMje {
  position: absolute;
}

.TimelineTab-module__relative___WJvxd {
  position: relative;
}

.TimelineTab-module__fixed___plP5J {
  position: fixed;
}

.TimelineTab-module__visible____MDbH {
  opacity: 1;
}

.TimelineTab-module__invisible___Tn4wI {
  opacity: 0;
}

.TimelineTab-module__col-90___LtLw7 {
  width: 90% !important;
}

.TimelineTab-module__col-auto___mHf8d {
  width: auto !important;
}

.TimelineTab-module__medical-tabs___S35jE {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TimelineTab-module__medical-table-new___Mt1po {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TimelineTab-module__medical-table-new___Mt1po:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TimelineTab-module__medical-table-new___Mt1po::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TimelineTab-module__medical-table-new___Mt1po::-webkit-scrollbar-track {
  display: none;
}
.TimelineTab-module__medical-table-new___Mt1po.TimelineTab-module__no-pagination___U_43M {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TimelineTab-module__medical-table-new___Mt1po.TimelineTab-module__no-pagination___U_43M:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TimelineTab-module__medical-table-new___Mt1po.TimelineTab-module__no-pagination___U_43M::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TimelineTab-module__medical-table-new___Mt1po.TimelineTab-module__no-pagination___U_43M::-webkit-scrollbar-track {
  display: none;
}

.TimelineTab-module__medical-table-empty___WoDO3 {
  padding: 14px 40px !important;
}

.TimelineTab-module__icon-btn___D654O {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TimelineTab-module__search-icon___uxoky {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TimelineTab-module__disable-select____ZwdR {
  user-select: none;
}

.TimelineTab-module__break-word___jamgQ {
  word-break: break-word;
}

.TimelineTab-module__popup-clear-btn___o6shN {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TimelineTab-module__scroll-m-b-20___Mv5sI {
  scroll-margin-bottom: 20px;
}

.TimelineTab-module__timeline___F2ldZ {
  position: relative;
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - 230px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.TimelineTab-module__timeline___F2ldZ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TimelineTab-module__timeline___F2ldZ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TimelineTab-module__timeline___F2ldZ::-webkit-scrollbar-track {
  display: none;
}
.TimelineTab-module__timeline___F2ldZ .TimelineTab-module__line___ZOQb8 {
  background: #859989;
  position: absolute;
  width: 1px;
  left: 53px;
  top: 48px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Labs/tabs/TimelineTab/TimelineTab.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;ECOA,kJDLE;ECMF,kBAAA;EACA,kBAAA;ADwpBF;ACtpBE;EACE,oCAAA;EACA,mBAAA;ADwpBJ;ACrpBE;EACE,UAAA;EACA,6BAAA;ADupBJ;ACppBE;EACE,aAAA;ADspBJ;AAnqBE;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;AAqqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.timeline {\n  position: relative;\n  @include verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(\n          --patient-details-footer\n        ) - 230px\n    )\n  );\n\n  .line {\n    background: get-color(greenNew, medium);\n    position: absolute;\n    width: 1px;\n    left: 53px;\n    top: 48px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TimelineTab-module__font-s-10___zP9OO`,
	"fontS12": `TimelineTab-module__font-s-12___aBgVC`,
	"fontS13": `TimelineTab-module__font-s-13___orH8c`,
	"fontS14": `TimelineTab-module__font-s-14___f4BL3`,
	"fontS15": `TimelineTab-module__font-s-15___CBcI1`,
	"fontS16": `TimelineTab-module__font-s-16___yaoBP`,
	"fontS18": `TimelineTab-module__font-s-18___nllZj`,
	"fontS20": `TimelineTab-module__font-s-20___3t6w3`,
	"fontS22": `TimelineTab-module__font-s-22___GE1_m`,
	"fontS28": `TimelineTab-module__font-s-28___wlAz8`,
	"fontW400": `TimelineTab-module__font-w-400___DdWGl`,
	"fontW500": `TimelineTab-module__font-w-500___RAMgV`,
	"fontW600": `TimelineTab-module__font-w-600___IOhVh`,
	"fontW700": `TimelineTab-module__font-w-700___RROa2`,
	"p5": `TimelineTab-module__p-5___tv4ol`,
	"p12": `TimelineTab-module__p-12___lEGSm`,
	"p16": `TimelineTab-module__p-16___nGOxC`,
	"p30": `TimelineTab-module__p-30___figqS`,
	"pB0": `TimelineTab-module__p-b-0___vBK1c`,
	"pB5": `TimelineTab-module__p-b-5___eLYke`,
	"pB10": `TimelineTab-module__p-b-10___s9tWp`,
	"pB12": `TimelineTab-module__p-b-12___H3D5n`,
	"pB16": `TimelineTab-module__p-b-16___zkAUF`,
	"pB18": `TimelineTab-module__p-b-18___frSoz`,
	"pB20": `TimelineTab-module__p-b-20___FM7t4`,
	"pB25": `TimelineTab-module__p-b-25___vNT3e`,
	"pB30": `TimelineTab-module__p-b-30___Un5_p`,
	"pB50": `TimelineTab-module__p-b-50___xpJ8S`,
	"pT0": `TimelineTab-module__p-t-0___drkxQ`,
	"pT12": `TimelineTab-module__p-t-12___vKzaU`,
	"pT16": `TimelineTab-module__p-t-16___pjjch`,
	"pT18": `TimelineTab-module__p-t-18___HOtrG`,
	"pT20": `TimelineTab-module__p-t-20___DcFlE`,
	"pT30": `TimelineTab-module__p-t-30___mWNMO`,
	"pT40": `TimelineTab-module__p-t-40___cUuTa`,
	"pT50": `TimelineTab-module__p-t-50___wYKuk`,
	"pL20": `TimelineTab-module__p-l-20___egobj`,
	"pL30": `TimelineTab-module__p-l-30___M_ud4`,
	"pL40": `TimelineTab-module__p-l-40___Esh1f`,
	"pR16": `TimelineTab-module__p-r-16___D7UZk`,
	"pR20": `TimelineTab-module__p-r-20___CtTAI`,
	"pR30": `TimelineTab-module__p-r-30___zaj31`,
	"pR50": `TimelineTab-module__p-r-50___OmxiI`,
	"pR60": `TimelineTab-module__p-r-60___kSL5J`,
	"mB1": `TimelineTab-module__m-b-1___AbmEC`,
	"mB2": `TimelineTab-module__m-b-2___laGij`,
	"mB6": `TimelineTab-module__m-b-6___c53tt`,
	"mB8": `TimelineTab-module__m-b-8___nrZfY`,
	"mB10": `TimelineTab-module__m-b-10___NApLA`,
	"mB14": `TimelineTab-module__m-b-14___i2lBq`,
	"mB16": `TimelineTab-module__m-b-16___NNs5G`,
	"mB20": `TimelineTab-module__m-b-20____vbQi`,
	"mB22": `TimelineTab-module__m-b-22___M1ai3`,
	"mB24": `TimelineTab-module__m-b-24___yf4yG`,
	"mB30": `TimelineTab-module__m-b-30___fRbMn`,
	"mB32": `TimelineTab-module__m-b-32___gul3L`,
	"mB40": `TimelineTab-module__m-b-40___cAncs`,
	"mT2": `TimelineTab-module__m-t-2___LJFzu`,
	"mT3": `TimelineTab-module__m-t-3___SuVs0`,
	"mT4": `TimelineTab-module__m-t-4___zVf4W`,
	"mT5": `TimelineTab-module__m-t-5___co0RO`,
	"mT8": `TimelineTab-module__m-t-8___JAblo`,
	"mT10": `TimelineTab-module__m-t-10___kPrcf`,
	"mT15": `TimelineTab-module__m-t-15___kKwxi`,
	"mT16": `TimelineTab-module__m-t-16___JSQP2`,
	"mT20": `TimelineTab-module__m-t-20___ipR27`,
	"mT22": `TimelineTab-module__m-t-22___BPQSE`,
	"mT30": `TimelineTab-module__m-t-30___CvzdJ`,
	"mT32": `TimelineTab-module__m-t-32___bOCTZ`,
	"mLAuto": `TimelineTab-module__m-l-auto___i38ji`,
	"mL4": `TimelineTab-module__m-l-4___tMSVo`,
	"mL5": `TimelineTab-module__m-l-5___mAjNU`,
	"mL6": `TimelineTab-module__m-l-6___UtQLs`,
	"mL8": `TimelineTab-module__m-l-8___sKmot`,
	"mL10": `TimelineTab-module__m-l-10___FWFC1`,
	"mL16": `TimelineTab-module__m-l-16___dU1Gz`,
	"mL20": `TimelineTab-module__m-l-20___akMXq`,
	"mL24": `TimelineTab-module__m-l-24___yyRFN`,
	"mL30": `TimelineTab-module__m-l-30___M2R8s`,
	"mL35": `TimelineTab-module__m-l-35___OGxSu`,
	"mL40": `TimelineTab-module__m-l-40___ufumg`,
	"mR8": `TimelineTab-module__m-r-8___yPf0K`,
	"mR10": `TimelineTab-module__m-r-10___NDhcq`,
	"mR16": `TimelineTab-module__m-r-16___NiGsy`,
	"mR20": `TimelineTab-module__m-r-20___GdHbE`,
	"mR24": `TimelineTab-module__m-r-24___WgCsf`,
	"mR30": `TimelineTab-module__m-r-30___DIJM_`,
	"mR40": `TimelineTab-module__m-r-40___eocs_`,
	"borderR3": `TimelineTab-module__border-r-3___YcsSZ`,
	"borderR4": `TimelineTab-module__border-r-4___hqjmk`,
	"borderR6": `TimelineTab-module__border-r-6___BslTj`,
	"borderR10": `TimelineTab-module__border-r-10___sA5Ak`,
	"borderR12": `TimelineTab-module__border-r-12___OwOo1`,
	"borderR16": `TimelineTab-module__border-r-16___S4JWw`,
	"borderR50": `TimelineTab-module__border-r-50___SE3Y_`,
	"primaryBorder": `TimelineTab-module__primary-border___juEzT`,
	"primaryBorderB": `TimelineTab-module__primary-border-b___L5zkv`,
	"primaryBorderT": `TimelineTab-module__primary-border-t___BLnQg`,
	"primaryBorderL": `TimelineTab-module__primary-border-l___hYm1t`,
	"primaryBorderR": `TimelineTab-module__primary-border-r____Xhzc`,
	"secondaryBorder": `TimelineTab-module__secondary-border___MwZIP`,
	"secondaryBorderB": `TimelineTab-module__secondary-border-b___I2VqW`,
	"secondaryBorderT": `TimelineTab-module__secondary-border-t___CBjIM`,
	"secondaryBorderL": `TimelineTab-module__secondary-border-l___ox0OL`,
	"secondaryBorderR": `TimelineTab-module__secondary-border-r___W5JoP`,
	"gap0": `TimelineTab-module__gap-0___pa6c0`,
	"gap2": `TimelineTab-module__gap-2___QCozg`,
	"gap4": `TimelineTab-module__gap-4___DiBjj`,
	"gap5": `TimelineTab-module__gap-5___W_AKF`,
	"gap6": `TimelineTab-module__gap-6___bvOEP`,
	"gap8": `TimelineTab-module__gap-8___zoEyg`,
	"gap10": `TimelineTab-module__gap-10___JdhNH`,
	"gap12": `TimelineTab-module__gap-12___uHriY`,
	"gap14": `TimelineTab-module__gap-14___ZN0Ha`,
	"gap16": `TimelineTab-module__gap-16___CfauV`,
	"gap18": `TimelineTab-module__gap-18___dx8Qm`,
	"gap20": `TimelineTab-module__gap-20___ZX9Ql`,
	"gap24": `TimelineTab-module__gap-24___jgVbt`,
	"gap26": `TimelineTab-module__gap-26___G3Wg1`,
	"gap30": `TimelineTab-module__gap-30___qhSeo`,
	"gap32": `TimelineTab-module__gap-32___vWLVP`,
	"gap40": `TimelineTab-module__gap-40___leUwX`,
	"gap50": `TimelineTab-module__gap-50___zZB7H`,
	"flex1": `TimelineTab-module__flex-1___e7TkB`,
	"flexNone": `TimelineTab-module__flex-none___d0BnB`,
	"flexColumn": `TimelineTab-module__flex-column___oezP_`,
	"flexRow": `TimelineTab-module__flex-row___wus0j`,
	"verticallyCentered": `TimelineTab-module__vertically-centered___tkotu`,
	"horizontallyCentered": `TimelineTab-module__horizontally-centered___sRcha`,
	"horizontallyEnd": `TimelineTab-module__horizontally-end___LY7lN`,
	"verticallyStart": `TimelineTab-module__vertically-start___Htznd`,
	"spaceBetween": `TimelineTab-module__space-between___P5kUT`,
	"flexWrap": `TimelineTab-module__flex-wrap___ObNba`,
	"height100": `TimelineTab-module__height-100___NUg7e`,
	"width50": `TimelineTab-module__width-50___GQyRE`,
	"width100": `TimelineTab-module__width-100___VVwOg`,
	"cursorPointer": `TimelineTab-module__cursor-pointer___lLhjF`,
	"cursorNotAllowed": `TimelineTab-module__cursor-not-allowed___GVVQC`,
	"absoluteCentered": `TimelineTab-module__absolute-centered___HwHmA`,
	"absolute": `TimelineTab-module__absolute___DVMje`,
	"relative": `TimelineTab-module__relative___WJvxd`,
	"fixed": `TimelineTab-module__fixed___plP5J`,
	"visible": `TimelineTab-module__visible____MDbH`,
	"invisible": `TimelineTab-module__invisible___Tn4wI`,
	"col90": `TimelineTab-module__col-90___LtLw7`,
	"colAuto": `TimelineTab-module__col-auto___mHf8d`,
	"medicalTabs": `TimelineTab-module__medical-tabs___S35jE`,
	"medicalTableNew": `TimelineTab-module__medical-table-new___Mt1po`,
	"noPagination": `TimelineTab-module__no-pagination___U_43M`,
	"medicalTableEmpty": `TimelineTab-module__medical-table-empty___WoDO3`,
	"iconBtn": `TimelineTab-module__icon-btn___D654O`,
	"searchIcon": `TimelineTab-module__search-icon___uxoky`,
	"disableSelect": `TimelineTab-module__disable-select____ZwdR`,
	"breakWord": `TimelineTab-module__break-word___jamgQ`,
	"popupClearBtn": `TimelineTab-module__popup-clear-btn___o6shN`,
	"scrollMB20": `TimelineTab-module__scroll-m-b-20___Mv5sI`,
	"timeline": `TimelineTab-module__timeline___F2ldZ`,
	"line": `TimelineTab-module__line___ZOQb8`
};
module.exports = ___CSS_LOADER_EXPORT___;
